import React from 'react'
import Helmet from 'react-helmet'
import { IntlProvider, addLocaleData } from 'react-intl'
import frData from 'react-intl/locale-data/fr'
import enData from 'react-intl/locale-data/en'
import './bootstrap.min.css'

import Header from '../Header/Header'
import SideMenu from '../SideMenu/SideMenu'
import Footer from '../Footer/Footer'
import fr from '../../i18n/fr.json'
import en from '../../i18n/en.json'

import icon57 from '../../assets/favicon/apple-icon-57x57.png'
import icon60 from '../../assets/favicon/apple-icon-60x60.png'
import icon72 from '../../assets/favicon/apple-icon-72x72.png'
import icon76 from '../../assets/favicon/apple-icon-76x76.png'
import icon114 from '../../assets/favicon/apple-icon-114x114.png'
import icon120 from '../../assets/favicon/apple-icon-120x120.png'
import icon144 from '../../assets/favicon/apple-icon-144x144.png'
import icon152 from '../../assets/favicon/apple-icon-152x152.png'
import icon180 from '../../assets/favicon/apple-icon-180x180.png'
import icon192 from '../../assets/favicon/android-icon-192x192.png'
import icon32 from '../../assets/favicon/favicon-32x32.png'
import icon96 from '../../assets/favicon/favicon-96x96.png'
import icon16 from '../../assets/favicon/favicon-16x16.png'
import manifest from '../../assets/favicon/manifest.json'

const messages = { fr, en }
addLocaleData([...frData, ...enData])

const Layout = ({ children, locale }) => {
  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <div className="container-fluid">
        <Helmet title="Banoi - Restaurant">
          <link rel="apple-touch-icon" sizes="57x57" href={icon57} />
          <link rel="apple-touch-icon" sizes="60x60" href={icon60} />
          <link rel="apple-touch-icon" sizes="72x72" href={icon72} />
          <link rel="apple-touch-icon" sizes="76x76" href={icon76} />
          <link rel="apple-touch-icon" sizes="114x114" href={icon114} />
          <link rel="apple-touch-icon" sizes="120x120" href={icon120} />
          <link rel="apple-touch-icon" sizes="144x144" href={icon144} />
          <link rel="apple-touch-icon" sizes="152x152" href={icon152} />
          <link rel="apple-touch-icon" sizes="180x180" href={icon180} />
          <link rel="icon" type="image/png" sizes="192x192" href={icon192} />
          <link rel="icon" type="image/png" sizes="32x32" href={icon32} />
          <link rel="icon" type="image/png" sizes="96x96" href={icon96} />
          <link rel="icon" type="image/png" sizes="16x16" href={icon16} />
          <link rel="manifest" href="" />

          <meta
            name="description"
            content="Chez Banoi, le rouleau de printemps est un plat. Comme au Vietnam. On le déguste seul, accompagné d'une soupe coco, de bouchées de banh-mi ou mˆme d'un verre de vin blacn. Tout est préparé sur place, avec nos petites mains et les légumes du marché voisin. Des rouleaux aux desserts nos recettes sont toutes faites maison et se déclinent au gré de nos inspirations."
          />
          <meta
            name="keywords"
            content="banoi, vietnam, restaurant, spring rolls, rouleaux de printemps"
          />

          <meta name="msapplication-TileColor" content="#ffffff" />
          <meta name="msapplication-TileImage" content={manifest} />
          <meta name="theme-color" content="#ffffff" />
        </Helmet>
        <Header locale={locale} />
        <div className="row no-gutters">
          <SideMenu />
          <div className="col-12 col-lg-10 order-first order-md-last">{children}</div>
        </div>

        <Footer />
      </div>
    </IntlProvider>
  )
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js